import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0edf8f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "heading-4 f-roboto fw-light" }, "EPX Dashboard", -1))
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "heading-4 f-roboto fw-light grey-1 mb-32" }, "EPX Release Notes", -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "white-box" }
const _hoisted_7 = { class: "heading-4 grey-1 fz-24 period-indicator mb-32" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "release-date" }
const _hoisted_10 = { class: "release-title" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "mt-80 mb-50"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_the_gradient = _resolveComponent("the-gradient")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, { "no-sidebar": false }, {
    "header-left": _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_DropDown, { class: "mb-32 ml-20" }, {
          label: _withCtx(() => [
            _createTextVNode(" Year: " + _toDisplayString(_ctx.year), 1)
          ]),
          list: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearList, (year) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => (_ctx.setYear(year)),
                key: year
              }, _toDisplayString(year), 9, _hoisted_4))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_DropDown, { class: "mb-32 ml-20" }, {
          label: _withCtx(() => [
            (_ctx.month !== null)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("Month: " + _toDisplayString(_ctx.monthList[_ctx.month - 1].label), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("Select Month")
                ], 64))
          ]),
          list: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthList, (m) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => (_ctx.setMonth(m.value)),
                key: m.value
              }, _toDisplayString(m.label), 9, _hoisted_5))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.month && _ctx.monthList[_ctx.month - 1].label) + " " + _toDisplayString(_ctx.year) + " Releases", 1),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.releaseNotes, (el) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "release-box",
              key: el.id
            }, [
              _createVNode(_component_the_gradient, {
                "gradient-type": 1,
                width: "10"
              }),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.format(new Date(el.release_date), ' MMM d, yyyy')), 1),
              _createElementVNode("h6", _hoisted_10, _toDisplayString(el.title), 1),
              _createElementVNode("div", {
                class: "release-content",
                innerHTML: el.notes
              }, null, 8, _hoisted_11)
            ]))
          }), 128))
        ])
      ]),
      (_ctx.pageMeta)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_ctx.pageMeta.current_page)
              ? (_openBlock(), _createBlock(_component_pagination, {
                  key: 0,
                  "current-page": _ctx.pageMeta.current_page,
                  "total-pages": _ctx.pageMeta.total,
                  meta: _ctx.pageMeta,
                  onHandleClick: _ctx.navigateToPage,
                  label: 'pages'
                }, null, 8, ["current-page", "total-pages", "meta", "onHandleClick"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}